const { mixpanel } = require('@fiverr-private/obs');

export const sendMixpanel = ({ type, ...params }) => {
    type ? mixpanel.track(type, params) : mixpanel.trackPageView(params);
};
